import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import type { ServiceInitArgs } from 'client/pages/app/services/base'
import { viewerKit } from 'compositions/mindmap'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'

export const MapClickEventPlugin = ({ action }: ServiceInitArgs) => {
  const { workbook } = storeToRefs(useWorkspaceStore())

  const handleOpenHref = async (topicId: string) => {
    if (!workbook.value) return
    const topicQuery = workbook.value.document.value.query({ id: topicId }).asTopic()
    const { href } = topicQuery
    action.common.openHref.execute({ href, sourceTopicId: topicId })
  }
  const handleClickInfoMoreIcon = () => action.ui.openInformationPopover.execute({ status: true })
  const handleClickLabel = () => action.ui.openLabelPopover.execute({ status: true })
  const handleClickNotes = () => action.ui.openNotePopover.execute({ status: true })

  const handleClickTopicInfo = async (request: viewerKit.TopicInfoOpenRequest) => {
    const { infoItemType, topicId } = request
    switch (infoItemType) {
      case 'note':
        return handleClickNotes()
      case 'web-link':
        return handleOpenHref(topicId)
      case 'multiple':
        return handleClickInfoMoreIcon()
      default:
        logger.log('Unprocessed Topic Info Click request: ', request)
    }
  }

  watch(
    () => workbook.value,
    newWorkbook => {
      if (newWorkbook) {
        newWorkbook.workbookEditor.installClickTopicInfoHandler(handleClickTopicInfo)
        newWorkbook.workbookEditor.installClickLabelHandler(handleClickLabel)
        newWorkbook.workbookEditor.installClickNotesHandler(request => {
          request?.topicId &&
            newWorkbook.workbookEditor.syncedProperties.value?.topicNotesDisplay?.value === 'block' &&
            action.ui.openNotePopover.execute({ status: true })
        })
      }
    },
    { immediate: true },
  )
}
